import axios from "axios";
import path from "../../path";

export const billingInformationApi = (data, providerId) => {
  return axios.put(
    `${path}/v1/provider/billing-information/${providerId}`,
    {
      data,
    }
    // {
    //   headers: headers.headers,
    // }
  );
};

export const billingInformationApiAdmin = (data, providerId, headers) => {
  return axios.put(
    `${path}/v1/provider/billing-information-admin/${providerId}`,
    {
      data,
    },
    {
      headers: headers.headers,
    }
  );
};

export const neuroVisualCoordinatorApi = (data, providerId) => {
  return axios.put(
    `${path}/v1/provider/neuro-visual-coordinator/${providerId}`,
    {
      data,
    }
  );
};

export const getNeuroVisualCoordinatorApi = (providerId) => {
  return axios.get(
    `${path}/v1/provider/neuro-visual-coordinator/${providerId}`
  );
};

export const getBillingInformationApi = (providerId) => {
  return axios.get(`${path}/v1/provider/billing-information/${providerId}`);
};

export const updateArchiveStatus = (providerId, data) => {
  return axios.put(
    `${path}/v1/provider/archive-status/${providerId}`,
    {
      data,
    }
  );
};

export const submitContactInfo = async (providerId, data) => {
  
  try {
    const dataToSend = {
      // isArchived: data?.isArchived || false,
      practiceNameAndAddress: {
        officeName: data?.officeName,
        streetAddress: data?.streetAddress,
        city: data?.city,
        state: data?.state,
        stateName: data?.stateName,
        country: data?.country,
        pinCode: data?.pinCode,
      },
      practiceContactInformation: {
        phone: data?.phone,
        fax: data?.fax,
        website: data?.website,
        email: data?.email,
        bvdqEmail: data?.bvdqEmail,
      },
      practiceManagerAdministrator: {
        firstName: data?.managerFirstName,
        lastName: data?.managerLastName,
        email: data?.managerEmail,
        phone: data?.managerPhone,
      },
      ownerContactInformation: {
        firstName: data?.ownerFirstName,
        lastName: data?.ownerLastName,
        email: data?.ownerEmail,
        phone: data?.ownerPhone,
        notes: data?.notes,
      },
      locationDetails: {
        locationStatus: data?.locationStatus || false,
        aboutMe: data?.aboutMe,
        medicalInsuranceStatus: data?.medicalInsuranceStatus || false,
        insurance_details: data?.insurance_details || [],
        // locationTag: data?.locationTag || "",
      },
      // practiceLogo: data?.practiceLogo || null,
    };

    const formData = new FormData();
    formData.append("data", JSON.stringify(dataToSend));
    formData.append("practiceLogo", data?.practiceLogo);

    const response = await axios.put(
      `${path}/v1/provider/practice-contact-info/${providerId}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error in putContactInfo: ${error.message}`);
  }
};

export const submitContactOnboardingInfo = async (providerId, data) => {
  try {
    const dataToSend = {
      practiceNameAndAddress: {
        officeName: data?.officeName,
        streetAddress: data?.streetAddress,
        city: data?.city,
        state: data?.state,
        country: data?.country,
        pinCode: data?.pinCode,
      },
      practiceContactInformation: {
        phone: data?.phone,
        fax: data?.fax,
        website: data?.website,
        email: data?.email,
      },
      practiceManagerAdministrator: {
        firstName: data?.managerFirstName,
        lastName: data?.managerLastName,
        email: data?.managerEmail,
        phone: data?.managerPhone,
      },
      ownerContactInformation: {
        firstName: data?.ownerFirstName,
        lastName: data?.ownerLastName,
        email: data?.ownerEmail,
        phone: data?.ownerPhone,
        notes: data?.notes,
      },
      locationDetails: {
        locationStatus: data?.locationStatus || false,
        aboutMe: data?.aboutMe,
        medicalInsuranceStatus: data?.medicalInsuranceStatus || false,
        insurance_details: data?.insurance_details || [],
      },
      // practiceLogo: data?.practiceLogo || null,
    };

    const formData = new FormData();
    formData.append("data", JSON.stringify(dataToSend));
    formData.append("practiceLogo", data?.practiceLogo);
    const response = await axios.put(
      `${path}/v1/provider/practice-contact-onboarding-info/${providerId}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error in putContactInfo: ${error.message}`);
  }
};

export const submitLocationContactOnboardingInfo = async (providerId, data) => {
  try {
    const dataToSend = {
      practiceManagerAdministrator: {
        firstName: data?.managerFirstName,
        lastName: data?.managerLastName,
        email: data?.managerEmail,
        phone: data?.managerPhone,
      },
      ownerContactInformation: {
        firstName: data?.ownerFirstName,
        lastName: data?.ownerLastName,
        email: data?.ownerEmail,
        phone: data?.ownerPhone,
        notes: data?.notes,
      },

      // practiceLogo: data?.practiceLogo || null,
    };

    const formData = new FormData();
    formData.append("data", JSON.stringify(dataToSend));
    formData.append("practiceLogo", data?.practiceLogo);
    const response = await axios.put(
      `${path}/v1/provider/practice-location-contact-onboarding-info/${providerId}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error in putContactInfo: ${error.message}`);
  }
};

export const getContactInfo = async (providerId) => {
  try {
    const response = await axios.get(
      `${path}/v1/provider/practice-contact-info/${providerId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching contact info:", error);
    throw error; // Re-throw error to be caught by the calling function
  }
};

export const submitGrowthAndfutureStategy = async (providerId, data) => {
  try {
    const response = await axios.put(
      `${path}/v1/provider/growth-future-strategy/${providerId}`,
      { data }
    );
    return response?.data;
  } catch (error) {
    console.error("Error updating form data:", error);
  }
};

export const getGrowthAndfutureStategy = async (providerId) => {
  try {
    const response = await axios.get(
      `${path}/v1/provider/growth-future-strategy/${providerId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching contact info:", error);
    throw error;
  }
};

export const getTrainingPreparation = async (providerId) => {
  try {
    const response = await axios.get(
      `${path}/v1/provider/staff-training/${providerId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching contact info:", error);
    throw error;
  }
};

export const submitTrainingPreparation = async (providerId, data) => {
  try {
    const response = await axios.put(
      `${path}/v1/provider/staff-training/${providerId}`,
      { data }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const submitTrainingPreparationNext = async (providerId, data) => {
  try {
    const response = await axios.put(
      `${path}/v1/provider/lab-practice-equipment-training/${providerId}`,
      { data }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const submitDoctorAndClinicalInformation = async (providerId, data) => {
  try {
    const dataToSend = {
      doctorPreferredName: data?.doctorName,
      firstName: data?.firstName,
      lastName: data?.lastName,
      // email: data?.primaryEmail,
      // secondaryEmail: data?.secondaryEmail,
      // cellPhone: data?.cellphone,
      // copeAndCECredits: {
      //   oeTrackerNumber: data?.oeTracker,
      //   licenseNumber: data?.licenseNumber,
      // },
      // clinicalPractices: {
      //   prismUsage: data?.prismUsage,
      //   neuroLensMachine: data?.neuroLensMachine,
      //   pretestingProcedures: data?.pretestingProcedures,
      //   testingProcedures: data?.testingProcedures,
      //   visionTherapy: data?.visionTherapy,
      // },
      // preferredContactMethod: data?.preferredContactMethod,
    };

    const formData = new FormData();
    // formData.append("doctorPreferredName", data?.doctorName);
    // formData.append("firstName", data?.firstName);
    // formData.append("lastName", data?.lastName);
    // formData.append("email", data?.primaryEmail);
    // formData.append("secondaryEmail", data?.secondaryEmail);
    // formData.append("cellPhone", data?.cellphone);
    // formData.append("copeAndCECredits[oeTrackerNumber]", data?.oeTracker);
    // formData.append("copeAndCECredits[licenseNumber]", data?.licenseNumber);
    // formData.append("clinicalPractices[prismUsage]", data?.prismUsage);
    // formData.append(
    //   "clinicalPractices[neuroLensMachine]",
    //   data?.neuroLensMachine
    // );
    // formData.append(
    //   "clinicalPractices[pretestingProcedures]",
    //   data?.pretestingProcedures
    // );
    // formData.append(
    //   "clinicalPractices[testingProcedures]",
    //   data?.testingProcedures
    // );
    // formData.append("clinicalPractices[visionTherapy]", data?.visionTherapy);
    // formData.append("preferredContactMethod", data?.preferredContactMethod);
    if (data?.doctorPhoto) {
      formData.append("photo", data?.doctorPhoto);
    }

    formData.append("data", JSON.stringify(dataToSend));

    const response = await axios.put(
      `${path}/v1/provider/doctor-clinic-info/${providerId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getDoctorAndClinicalInformation = async (providerId) => {
  try {
    const response = await axios.get(
      `${path}/v1/provider/doctor-clinic-info/${providerId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const opticalApi = (data, providerId) => {
  return axios.put(`${path}/v1/provider/optical/${providerId}`, {
    data,
  });
};

export const getOpticalApi = (providerId) => {
  return axios.get(`${path}/v1/provider/optical/${providerId}`);
};

export const billingApi = (data, providerId) => {
  return axios.put(`${path}/v1/provider/billing/${providerId}`, {
    data,
  });
};

export const getBillingApi = (providerId) => {
  return axios.get(`${path}/v1/provider/billing/${providerId}`);
};

export const updateDepIntData = (data, providerId) => {
  return axios.put(`${path}/v1/provider/department-of-interest/${providerId}`, {
    data,
  });
};

export const getDepIntDataApi = (providerId) => {
  return axios.get(`${path}/v1/provider/staff-training/${providerId}`);
};

export const staffingTrainingApi = (data, providerId) => {
  return axios.put(`${path}/v1/provider/staffing-and-training/${providerId}`, {
    data,
  });
};

export const getStaffingTrainingApi = (providerId) => {
  return axios.get(`${path}/v1/provider/staffing-and-training/${providerId}`);
};

export const validateProviderApi = (providerId) => {
  return axios.get(`${path}/v1/provider/validate-provider/${providerId}`);
};

export const providerNameApi = (providerId) => {
  return axios.get(`${path}/v1/provider/provider-name/${providerId}`);
};

export const createAuditLogs = (data, headers) => {
  return axios.post(`${path}/v1/logs/create-logs`, data, headers);
};
